const STORAGE_COLUMNS_NAME = 'invoices-columns';

const COLUMN_OPTIONS = [
    {
        value: 'from',
        label: 'From',
    },
    {
        value: 'type',
        label: 'Type',
    },
    {
        value: 'business',
        label: 'Total Business',
    },
    {
        value: 'to',
        label: 'To',
    },
    {
        value: 'payDate',
        label: 'Pay Date',
    },
    {
        value: 'subtotal',
        label: 'Subtotal',
    },
    {
        value: 'taxes',
        label: 'Taxes',
    },
    {
        value: 'total',
        label: 'Total',
    },
    {
        value: 'currency',
        label: 'Currency',
    },
    {
        value: 'paymentMethod',
        label: 'Payment Method',
    },
    {
        value: 'expiredAt',
        label: 'Expired Date',
    },
    {
        value: 'gateway',
        label: 'Payment Gateway',
    },
    {
        value: 'frequency',
        label: 'Frequency',
    },
];

export {
    COLUMN_OPTIONS,
    STORAGE_COLUMNS_NAME,
};
